export default __webpack_public_path__ + "static/media/colarityScreenshot3.c4ea28d3.png";